const ModalHook = {
  isHidden() {
    return window.getComputedStyle(this.el).display === 'none';
  },

  mounted() {
    this.handleEvent(`modal:hide:${this.el.id}`, () => {
      liveSocket.execJS(this.el, this.el.dataset.cancel);
    });

    this.handleEvent(`modal:show:${this.el.id}`, () => {
      liveSocket.execJS(this.el, this.el.dataset.show);
    });
  },
};

export default ModalHook;
